module.exports = "/assets/data/36087aefe7dccb172ebae58fb4bb7853-GU14.data.json";